import React, { useEffect } from 'react';
import cn from 'classnames';
import get from 'lodash/get';
import PropTypes from 'prop-types';

import Loader from '../../common/Loader';
import AppointmentHeader from '../Components/AppointmentHeader';
import AppointmentPaymentForm from '../../Healthboard/Components/AppointmentDetailsPopup/AppointmentPaymentForm';
import { redirectToHealthBoard } from '../../../utils/appointments/redirect-utils';
import { couponUrgentVisit } from '../../../redux/appointmentForm/sagas/paymentUrgentVisit';
import { useInjectSaga } from '../../../redux/injectSaga';
import { RESTART_ON_REMOUNT } from '../../../redux/sagaInjectors';
import { enhance } from './enhance';

import styles from './styles.styl';
import { usePageView } from '../../../hocs/usePageView';
import MetaHelmet from '../../AppHelmet/MetaHelmet';

function AppointmentPayment({
  appointment,
  isUrgentVisit,
  confirmUrgentVisit,
  urgentVisitPending,
  intl: { formatMessage },
}) {
  useInjectSaga({
    key: 'couponUrgentVisit',
    saga: couponUrgentVisit,
    mode: RESTART_ON_REMOUNT,
  });

  const userId = get(appointment, 'userId');
  usePageView('Get Care | Payment');

  useEffect(() => {
    if (isUrgentVisit) {
      confirmUrgentVisit();
    }
  }, []);

  return urgentVisitPending ? (
    <Loader />
  ) : (
    appointment && (
      <div className={styles.payment}>
        <MetaHelmet title="pages.title.getCare.payment" />
        <AppointmentHeader
          titleClassName={styles.content}
          title="appointment.payment.title"
          handleBack={() => userId && redirectToHealthBoard(userId)}
        />

        <div className={cn(styles.content, styles.form)}>
          <AppointmentPaymentForm
            appointment={appointment}
            formatMessage={formatMessage}
          />
        </div>
      </div>
    )
  );
}

AppointmentPayment.propTypes = {
  intl: PropTypes.object,
  appointment: PropTypes.object,
  isUrgentVisit: PropTypes.bool,
  confirmUrgentVisit: PropTypes.func,
  urgentVisitPending: PropTypes.bool,
};

export default enhance(AppointmentPayment);



// WEBPACK FOOTER //
// ./src/components/AppointmentForm/AppointmentPayment/index.js